import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { SharedModule } from "src/app/shared/shared.module";
import { ReportAccessComponent } from "./components/report-access/report-access.component";
import { ReportImageDialogComponent } from "./components/report-image-dialog/report-image-dialog.component";
import { ReportInventoryComponent } from "./components/report-inventory/report-inventory.component";
import { ReportServiceRequestComponent } from "./components/report-service-request/report-service-request.component";
import { ReportRoutingModule } from "./report-routing.module";

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ReportRoutingModule,
    SharedModule,
  ],
  declarations: [
    ReportServiceRequestComponent,
    ReportInventoryComponent,
    ReportImageDialogComponent,
    ReportAccessComponent,
  ],
  exports: [ReportServiceRequestComponent],
  entryComponents: [ReportImageDialogComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ReportModule {}
